import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const EquipmentDetails = lazyLoader(
  () => import("Containers/Equipment/EquipmentDetails/EquipmentDetails")
);

export const EquipmentDetailsPage = () => {
  return (
    <Layout>
      <EquipmentDetails />
    </Layout>
  );
};
